import { ElementHTML } from '@helpers/helper.rendering'
import { Link } from 'gatsby'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'

const AboutUs_22 = (props: RealEstateDataPageComponentData) => {
  const { title, titleElement, titleHexa, paragraphs, button } = props
  return (
    <section
      id="about-us-22 "
      className="about-22 p-y-config"
    >
      <Container fluid>
        <Row>
          <Col lg={12}>
            <ElementHTML
              children={title ?? ''}
              elementType={titleElement ?? 'h2'}
              className={'mb-lg-4 mb-3'}
              style={{ color: titleHexa }}
            />
            {paragraphs?.map((paragraph, index) => <p key={index}>{paragraph}</p>)}
          </Col>
          <Col
            lg={12}
            className="mt-3"
          >
            {button && (
              <Link
                to={button.link || ''}
                className={`btn btn-primary ${button.border ? 'border' : ''} mt-3`}
              >
                {button.value}
                {button.image && (
                  <img
                    src={button.image}
                    className="button-logo"
                  />
                )}
              </Link>
            )}
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default AboutUs_22
